import styled from 'styled-components/macro';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const StyedBurgerContainer = styled.div``;

export const StyledBurgerImage = styled.img`
  cursor: pointer;
`;

export const StyledBurgerMenu = styled.div`
  background: ${COLORS.multiGray};
  position: absolute;
  top: 50px;
  left: 0;
  height: 100vh;
  width: 100vw;
  border-top:1px solid ${COLORS.lightGray};
  padding-top: 52px;
  
`;

export const StyledImage = styled.img``;

export const StyledContent = styled.div`
  ${FLEX_CONTAINER.FlexColumn};
  width: max-content;
  margin: auto;
  align-items: flex-start;
  grid-gap: 34px;
`;

export const StyledUserNameContainer = styled.div`
  ${FLEX_CONTAINER.FlexRow};
  cursor: pointer;
  column-gap: 20px;
`;
